/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_View_PdfInputs */

const vi_einvoice_view_pdf = /** @type {(inputs: Einvoice_View_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem PDF`)
};

/**

* @param {Einvoice_View_PdfInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_view_pdf = /** @type {((inputs?: Einvoice_View_PdfInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_View_PdfInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_view_pdf(inputs)
});